import { render, staticRenderFns } from "./DT_Attributes.vue?vue&type=template&id=519b7353&scoped=true&"
import script from "./DT_Attributes.vue?vue&type=script&lang=js&"
export * from "./DT_Attributes.vue?vue&type=script&lang=js&"
import style0 from "./DT_Attributes.vue?vue&type=style&index=0&id=519b7353&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519b7353",
  null
  
)

export default component.exports